import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../helpers/api';
import {
  ROLE_LIST_GET_LIST,
  USER_LIST_GET_LIST,
  PROPERTY_LIST_GET_LIST,
  AGENT_LIST_GET_LIST,
} from '../actions';

import {
  getRoleListSuccess,
  getRoleListError,
  getPropertyListSuccess,
  getPropertyListError,
  getUserListSuccess,
  getUserListError,
  getAgentsListSuccess,
  getAgentsListError,
} from './actions';

import roleListData from '../../data/rolelist.json';
import userListData from '../../data/user.list.json';

import { gAPI_Property_List, gAPI_Users_By_Id } from '../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../helpers/AxiosAPI';

const getRoleListRequest = async () => {
  const roles = roleListData.data;
  return await new Promise((success, fail) => {
    setTimeout(() => {
      success({ roles });
    }, 2000);
  })
    .then((response) => response)
    .catch((error) => error);
};

const getPropertyListRequest = async () => {
  return await new Promise((success, fail) => {
    setTimeout(() => {
      const AUTHORITY_SERVER =
        process.env && process.env.REACT_APP_AUTHORITY_SERVER;
      const ACCESS_TOKEN = JSON.parse(
        sessionStorage.getItem(
          `oidc.user:${AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
        )
      ).access_token;

      let GROUP_ID = JSON.parse(
        sessionStorage.getItem(
          `oidc.user:${process.env.REACT_APP_AUTHORITY_SERVER}:${process.env.REACT_APP_IDENTITY_SERVER_CLIENT_APP_ID}`
        )
      ).profile.nickname;

      // console.log('ACCESS_TOKEN IS', ACCESS_TOKEN);
      //console.log('GROUP_ID IS', GROUP_ID);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      }).then((res) => {
        // console.log('res', res.data);

        AxiosAPI({
          method: 'get',
          url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
        }).then((res1) => {
          if (
            res1.data.properties.length > 0 &&
            res1.data.properties[0] === '-1'
          ) {
            //  this.setState({ propertyList: res.data });
            success({ properties: res.data });
          } else {
            const finalResult = [];
            res.data.forEach((p) => {
              res1.data.properties.forEach((r) => {
                if (p.id === r) {
                  finalResult.push(p);
                }
              });
            });
            //this.setState({ propertyList: finalResult });
            success({ properties: finalResult });
          }
        });
      });
      // getRequest(`/properties/${GROUP_ID}`)
      //   .then(response => response.json())
      //   .then(data => {
      //     success({ properties: data });
      //   });
    });
  })
    .then((response) => response)
    .catch((error) => error);
};

const getUserListRequest = async () => {
  const users = userListData.data;
  return await new Promise((success, fail) => {
    setTimeout(() => {
      success({ users });
    }, 2000);
  })
    .then((response) => response)
    .catch((error) => error);
};

const getAgentsListRequest = async () => {
  return await new Promise((success, fail) => {
    setTimeout(() => {
      getRequest('/agents')
        .then((response) => response.json())
        .then((data) => {
          success({ data });
        });
    });
  })
    .then((response) => response)
    .catch((error) => error);
};

function* getRoleListItems() {
  try {
    const response = yield call(getRoleListRequest);
    const { roles } = response;
    //console.log(roles);
    yield put(getRoleListSuccess(roles));
  } catch (error) {
    yield put(getRoleListError(error));
  }
}

function* getPropertyListItems() {
  try {
    const response = yield call(getPropertyListRequest);
    const { properties } = response;
    yield put(getPropertyListSuccess(properties));
  } catch (error) {
    yield put(getPropertyListError(error));
  }
}

function* getUserListItems() {
  try {
    const response = yield call(getUserListRequest);
    const { users } = response;
    //console.log(users);
    yield put(getUserListSuccess(users));
  } catch (error) {
    yield put(getUserListError(error));
  }
}

function* getAgentsListItem() {
  try {
    const response = yield call(getAgentsListRequest);
    const { data } = response;
    yield put(getAgentsListSuccess(data));
  } catch (error) {
    yield put(getAgentsListError(error));
  }
}

export function* watchGetList() {
  yield takeEvery(ROLE_LIST_GET_LIST, getRoleListItems);
  yield takeEvery(PROPERTY_LIST_GET_LIST, getPropertyListItems);
  yield takeEvery(USER_LIST_GET_LIST, getUserListItems);
  yield takeEvery(AGENT_LIST_GET_LIST, getAgentsListItem);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}
